var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 258.83,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 258.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        mask: url(#mask);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1743.15,
    y1: 2396.84,
    x2: -1720.76,
    y2: 2396.84,
    gradientTransform: "translate(-2183.22 -1603.93) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 192.63,
    y: 51.41,
    width: 149.49,
    height: 149.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pg0gl4d9eb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m247.66,61.4c-9.16.05-18.09,2.81-25.68,7.94l32.55,32.13c3.67,3.59,3.74,9.54.07,13.21-3.63,3.67-9.54,3.7-13.21.07l-32.55-32.13c-5.01,7.66-7.64,16.63-7.59,25.78.17,25.73,21.24,46.55,47.01,46.41,4.07-.04,8.12-.6,12.04-1.68l12.55,12.39h0s2.59,2.55,2.59,2.55l.72.71,26.72,26.16c3.68,3.61,9.6,3.55,13.21-.13,0,0,0,0,0,0l19.61-20.03c3.61-3.69,3.55-9.6-.14-13.21l-27.17-26.6-4.4-4.36-.03-.03-10.85-10.69c1.06-3.94,1.58-8,1.56-12.08-.14-25.76-21.24-46.55-47.01-46.41h0Zm37.66,46.48c.05,5.01-.92,9.98-2.85,14.6l16.52,16.34h-.01s2.71,2.67,2.71,2.67l.6.6,26.72,26.16-19.61,20.03-27.33-26.76-19.32-19.11c-4.59,2.01-9.56,3.05-14.57,3.06-20.61.15-37.47-16.55-37.59-37.13,0-3.34.43-6.58,1.22-9.66l23,22.71c3.57,3.5,8.28,5.43,13.27,5.41,4.99-.02,9.66-1.99,13.16-5.56,3.53-3.54,5.43-8.28,5.41-13.27s-1.99-9.66-5.56-13.16l-23-22.71c3.13-.89,6.38-1.35,9.63-1.36,20.61-.15,37.5,16.51,37.59,37.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m197.31,139.22v-22.39h32.63v22.39h-32.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m228.3,119.61l-12.16,1.89h-18.62l-.38-42.05h32.89l9.34,28.03s-11.08,12.13-11.08,12.13Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Black",
    className: "cls-3",
    d: "m126.08,116.98l13.67,44.63c.09.29.04.62-.14.87l-38.53,54.68c-1.08,1.53-2.84,2.48-4.71,2.51C29.2,220.7-1.27,170.01.04,126.79,1.37,82.92,34.02,39.21,92.84,39.21c38.69,0,65.79,28.76,74.5,43.13,6.27,9.41,13.07,33.55,15.69,44.44,22.22,79.73,57.51,90.19,90.19,90.19,41.82,0,84.96-33.98,84.96-90.19-1.31-50.98-50.93-84.96-84.96-84.96s-62.02,12.73-84.11,53.25c-.38.7-1.4.72-1.78.02l-22.32-40.92c-.19-.36-.15-.79.1-1.11C192.47,19.41,225.06,0,273.22,0c77.12,0,126.78,69.27,126.78,126.79,0,99.34-86.27,132.01-126.78,132.01-49.15,1.05-82.35-27.45-92.8-41.83-18.82-19.87-34.85-68.4-40.52-90.19-6.27-35.55-33.98-45.31-47.05-45.75-36.6-1.05-49.23,30.06-50.98,45.75-.97,33.78,22.5,46.4,37.08,49.17,2.12.4,4.2-.6,5.44-2.36l39.92-56.9c.48-.68,1.53-.51,1.78.28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Build"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m192.63,51.41h149.49v149.49h-149.49V51.41Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 216.01,
    cy: 98.01,
    r: 14.02
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildBlack);
export default __webpack_public_path__ + "static/media/build_black.bf043daa176d239c6b9107bf835493e6.svg";
export { ForwardRef as ReactComponent };